import http from "./http"
import endpoints from "./endpoints"

import axios from 'axios'
import { baseUrl } from "./env";

const token = localStorage.getItem("token");

export const login = async (data) => {
    return http.post(`${endpoints.login}`, data)
}

export const sendOtp = async (data) => {
    return http.post(`${endpoints.sendOtp}`, data)
}


export const verifyOtp = async (data) => {
    return http.post(`${endpoints.verifyOtp}`, data)
}


export const resetPassword = async (data) => {
    return http.resetPassword(`${endpoints.resetPassword}`, data)
}

export const staticContent = async (data) => {
    return http.get(`${endpoints.allContent}`, data)
}

export const updateContent = async (id, { content }) => {
    return http.patch(`${endpoints.updateContent}/${id}`, { description: content })
}

export const createContent = async (data) => {
    return http.post(`${endpoints.createContent}`, data)
}


export const getFaqs = async () => {
    return http.get(`${endpoints.getFaqs}`)
}

export const updateFaq = async (id, data) => {
    return http.patch(`${endpoints.editFaqs}/${id}`, data)
}

export const deleteFaqs = async (id) => {
    return http.delete(`${endpoints.deleteFaqs}/${id}`)
}

export const addFaqs = async (data) => {
    return http.post(`${endpoints.addFaq}`, data)
}

export const getAllUsers = async () => {
    return http.get(`${endpoints.getAllUser}`)
}

export const getAllCards = async () => {
    return http.get(`${endpoints.getAllCards}`)
}


export const deleteCard = async (id) => {
    return http.delete(`${endpoints.deleteCardDetails}/${id}`)
}

export const updateCard = async (id, data) => {
    return http.patchFormData(`${endpoints.editCardDetails}/${id}`, data)
}

export const addCard = async (data) => {
    return http.postFormData(`${endpoints.addCardDetails}`, data)
}

export const addThankYouCard = async (data) => {
    return http.postFormData(`${endpoints.addThankYou}`, data)
}

export const getThankYouCard = async () => {
    return http.get(`${endpoints.getThanksCard}`,)
}

export const deleteThankYouCard = async (id) => {
    return http.delete(`${endpoints.deleteThanksCard}/${id}`,)
}
export const updateThankYouCard = async (id, data) => {
    return http.patchFormData(`${endpoints.updateThankCard}/${id}`, data)
}